<template>
    <div class="maze-game" v-bind:style="{ height: containerHeight + 'px' }">
        <resize-observer @notify="handleResize" />
        <div class="actions">
            <Toolbar v-on:execute="execute" v-on:stop="stop" :is-running="isRunning"></Toolbar>
            <codemirror ref="editor" class="code" v-model="code" :options="cmOption"></codemirror>
        </div>
        <div class="maze">
            <button style="margin: 6px;" v-on:click="randomMaze()"><i class="fa fa-refresh" aria-hidden="true" ></i> Cambiar Laberinto</button>
            <Maze :maze="maze"></Maze>
            <div style="text-align: left; padding: 10px; color: #444;">
                <p>SubProcesos disponibles para controlar el laberinto:</p>
                <div style="margin-left: 15px;">
                    <p><strong>avanzar();</strong> <br/>Avanza una celda en la dirección actual</p>
                    <p><strong>derecha();</strong> <br/>Rota hacia la derecha sin moverse</p>
                    <p><strong>izquierda();</strong> <br/>Rota hacia la izquierda sin moverse</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Maze from './Maze'
    import Parser from '../../Core/Parser/Parser'
    import VirtualMachine from '../../Core/VirtualMachine/VirtualMachine'

    import 'vue-resize/dist/vue-resize.css'
    import { ResizeObserver } from 'vue-resize'

    import { codemirror } from 'vue-codemirror'
    import 'codemirror/lib/codemirror.css'
    import 'codemirror/addon/lint/lint.css'
    import 'codemirror/addon/display/autorefresh.js'
    import 'codemirror/addon/mode/simple.js'
    import 'codemirror/addon/lint/lint.js'
    import 'codemirror/addon/selection/mark-selection.js'
    import 'codemirror/addon/search/searchcursor.js'
    import 'codemirror/addon/search/match-highlighter.js'
    import 'codemirror/addon/selection/active-line.js'

    import Toolbar from './../CodeEditor/Toolbar'
    import './../../Codemirror/mode'
    import './../../Codemirror/lint'

    export default {
        name: 'TabMazeGame',
        props: ['id'],
        components: {
            Maze,
            codemirror,
            ResizeObserver,
            Toolbar
        },
        created () {
            this.randomMaze()
        },
        beforeDestroy () {
            localStorage.removeItem('villacodigo_maze_game_' + this.id)
        },
        mounted () {
            this.containerHeight = this.$el.parentElement.clientHeight - 60
            var code = localStorage.getItem('villacodigo_maze_game_' + this.id)
            if (!code) {
                code = `Proceso Laberinto1\n\tavanzar();\n\tderecha();\n\tavanzar();\n\tizquierda();\n\tavanzar();\nFinProceso`
            } else {
                code = JSON.parse(code)
            }
            this.code = code
        },
        watch: {
            code (newCode) {
                localStorage.setItem('villacodigo_maze_game_' + this.id, JSON.stringify(newCode))
            }
        },
        methods: {
            randomInt (min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min
            },
            randomMaze () {
                // Build data structure and outter walls
                for (let y = 1; y <= this.maze.height; y++) {
                    this.maze.cells[y] = []
                    for (let x = 1; x <= this.maze.width; x++) {
                        this.maze.cells[y][x] = {
                            isWall: false
                        }
                        if (y === 1 || y === this.maze.height) {
                            this.maze.cells[y][x].isWall = true
                        }
                        if (x === 1 || x === this.maze.width) {
                            this.maze.cells[y][x].isWall = true
                        }
                    }
                }

                // Start and finish
                this.maze.start.x = this.randomInt(2, this.maze.width / 2)
                this.maze.start.y = this.maze.height

                this.maze.finish.x = this.randomInt(this.maze.width / 2 + 1, this.maze.width - 1)
                this.maze.finish.y = 1

                if (this.randomInt(1, 2) === 1) {
                    let tmp
                    tmp = this.maze.start.x
                    this.maze.start.x = this.maze.finish.x
                    this.maze.finish.x = tmp
                }

                this.maze.cells[this.maze.start.y][this.maze.start.x].isWall = false
                this.maze.cells[this.maze.finish.y][this.maze.finish.x].isWall = false

                // Fill the maze with some walls
                for (let i = 0; i < this.maze.width * this.maze.height * 0.1; i++) {
                    let x = this.randomInt(2, this.maze.width - 1)
                    let y = this.randomInt(2, this.maze.height - 1)
                    this.maze.cells[y][x].isWall = true
                }

                this.maze.cells[this.maze.start.y - 1][this.maze.start.x].isWall = false
                this.maze.cells[this.maze.finish.y + 1][this.maze.finish.x].isWall = false

                this.maze.arrow.x = this.maze.start.x
                this.maze.arrow.y = this.maze.start.y
            },
            forward () {
                let sumVector = this.maze.moveForward[this.maze.arrow.direction]
                let newPos = {
                    x: this.maze.arrow.x + sumVector.x,
                    y: this.maze.arrow.y + sumVector.y
                }
                if (this.maze.cells[newPos.y][newPos.x].isWall) {
                    return false
                }
                this.maze.arrow.x = newPos.x
                this.maze.arrow.y = newPos.y
                return true
            },
            rotateRight () {
                this.maze.arrow.direction = this.maze.rotations.right[this.maze.arrow.direction]
            },
            rotateLeft () {
                this.maze.arrow.direction = this.maze.rotations.left[this.maze.arrow.direction]
            },
            handleResize () {
                this.containerHeight = this.$el.parentElement.clientHeight
            },
            markLine (lineNro) {
                if (this.markedLine !== null) {
                    this.markedLine.clear()
                }
                this.markedLine = this.$refs.editor.codemirror.markText({line: lineNro, ch: 0}, {line: lineNro, ch: 9999}, {className: 'cm-selected-text'})
            },
            stop () {
                this.vm.stop()
                this.isRunning = false
                if (this.markedLine !== null) {
                    this.markedLine.clear()
                }
            },
            execute () {
                let parser = new Parser({
                    config: window.LangConfig,
                    externalFunc: this.externalFunc
                })
                let program = parser.parse(this.code)
                let that = this

                this.isRunning = true
                this.maze.arrow.x = this.maze.start.x
                this.maze.arrow.y = this.maze.start.y
                this.maze.arrow.direction = 'up'

                function stepCb (ins, continueCb) {
                    if (ins.debug !== undefined && ins.debug.fromLine !== undefined && ins.debug.fromLine !== null) {
                        that.markLine(ins.debug.fromLine)
                    }
                    continueCb()
                }
                function readCb (readDone) {
                }
                function endCb () {
                    if (that.markedLine !== null) {
                        that.markedLine.clear()
                    }

                    that.isRunning = false
                }
                function writeCb (value, continueCb) {
                    continueCb()
                }
                function errorCb (type, lineStart, colStart, lineEnd, colEnd, lexema, index) {
                }
                function extraFunctionCall (name, args, continueCb) {
                    let allowedMove = true
                    if (name === 'avanzar') {
                        allowedMove = that.forward()
                    } else if (name === 'derecha') {
                        that.rotateRight()
                    } else if (name === 'izquierda') {
                        that.rotateLeft()
                    }
                    if (allowedMove) {
                        setTimeout(() => {
                            that.$nextTick(() => {
                                continueCb()
                            })
                        }, 500)
                    } else {
                        alert('Has chocado contra la pared.')
                        that.isRunning = false
                    }
                }

                if (program !== false) {
                    this.vm = new VirtualMachine(program)
                    setTimeout(() => {
                        that.$nextTick(() => {
                            that.vm.execute(stepCb, endCb, writeCb, readCb, extraFunctionCall, errorCb)
                        })
                    }, 200)
                } else {
                    console.log('Error al parsear.')
                }
            }
        },
        data () {
            return {
                vm: null,
                readDoneCb: null,
                readValue: false,
                screenLines: [],
                containerHeight: 600,
                code: '',
                markedLine: null,
                cmOption: {
                    tabSize: 4,
                    lineNumbers: true,
                    mode: 'psflex',
                    gutters: ['CodeMirror-lint-markers', 'mark-selection'],
                    lint: true,
                    styleSelectedText: true,
                    styleActiveLine: true,
                    line: true,
                    autoRefresh: true
                },
                isRunning: false,
                externalFunc: {
                    avanzar: {
                        isMethod: true,
                        args: {}
                    },
                    derecha: {
                        isMethod: true,
                        args: {}
                    },
                    izquierda: {
                        isMethod: true,
                        args: {}
                    }
                },
                maze: {
                    width: 8,
                    height: 8,
                    cells: [],
                    arrow: {
                        x: 1,
                        y: 6,
                        direction: 'up'
                    },
                    start: {
                        x: 1,
                        y: 6
                    },
                    finish: {
                        x: 5,
                        y: 1
                    },
                    moveForward: {
                        up: {
                            x: 0,
                            y: -1
                        },
                        left: {
                            x: -1,
                            y: 0
                        },
                        down: {
                            x: 0,
                            y: 1
                        },
                        right: {
                            x: 1,
                            y: 0
                        }
                    },
                    rotations: {
                        left: {
                            up: 'left',
                            left: 'down',
                            down: 'right',
                            right: 'up'
                        },
                        right: {
                            up: 'right',
                            left: 'up',
                            down: 'left',
                            right: 'down'
                        }
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .maze-game {
        position: relative;
        width: 100%;
        padding: 0px;
        margin: 0px;
    }

    .maze-game > .actions {
        position: absolute;
        left: 0px;
        top: 0px;
        bottom: 0px;
        right: 50%;
        padding: 0px;
        margin: 0px;
    }
    .maze-game > .maze {
        position: absolute;
        left: 50%;
        top: 0px;
        bottom: 0px;
        right: 0px;
        padding: 0px;
        margin: 0px;
        text-align: center;
        padding-top: 20px;
        border-left: 1px solid #888;
        background-color: #D9E4AF;
    }
</style>


// WEBPACK FOOTER //
// src/Components/MazeGame/MazeGame.vue